import { render, staticRenderFns } from "./Fora.vue?vue&type=template&id=19dab2b5"
import script from "./Fora.vue?vue&type=script&lang=js"
export * from "./Fora.vue?vue&type=script&lang=js"
import style0 from "./Fora.vue?vue&type=style&index=0&id=19dab2b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports